// extracted by mini-css-extract-plugin
export default {"swiper":"HeroesRow_swiper__5pq8A","swiperSlide":"HeroesRow_swiperSlide__oKMFS","swiperWrapper":"HeroesRow_swiperWrapper__crmvO"};